module.exports = __webpack_public_path__ + "assets/img/sabc_main_logo.svg?ada8fd4e1cb4252a1f2e4f3971e26ec5";